import React from "react";
import NotFound, { NotFoundPage } from ".";

const NotFoundWrapper = () => {
  const token = localStorage.getItem("access_token");
  if (!token) {
    window.location.replace("/login");
    return null;
  }
  return <NotFound />;
};

export default NotFoundWrapper; 